// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"304":"Create","570":"Moderate","958":"Voting"}[chunkId] || chunkId) + "." + {"113":"af812e0d","184":"923f2408","304":"32bac4fa","461":"68e1d113","472":"e335c5e8","491":"67153088","534":"17a192af","570":"58ec0187","787":"c4e7f8f9","958":"88a61c6a"}[chunkId] + ".chunk.js";
};